export default __webpack_public_path__ + "static/research-democratizing-b1fb580da8c13324d717123ec2006514.png";